<script lang="ts">
	import type { PageData } from './$types';
	import BrandHero from '$lib/components/BrandHero.svelte';
	import BrandFeatures from '$lib/components/BrandFeatures.svelte';
	import PageContainer from '$lib/components/PageContainer.svelte';

	let { data }: { data: PageData } = $props();
</script>

<svelte:head>
	<title>{data.config.productName} - {data.config.displayName}</title>
	<meta name="description" content={data.config.productDescription} />
	<meta property="og:title" content="{data.config.productName} - {data.config.displayName}" />
	<meta property="og:type" content="website" />
</svelte:head>

<PageContainer config={data.config} transparent={true}>
	<BrandHero config={data.config} />
	<BrandFeatures config={data.config} />
</PageContainer>
